import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

const MIN = 0;
const MAX = 300000;
const STEP = 5000;

const fmt = (v) => v >= 1000 ? `$${(v / 1000).toFixed(0)}k` : `$${v}`;

const JobHeaderDDSalary = ({ minSalary, maxSalary, setMinSalary, setMaxSalary }) => {
    return (
        <div>
            <style>{`
                .cc-salary .rc-slider-rail { background-color: #e5e7eb; height: 6px; }
                .cc-salary .rc-slider-track { background-color: #3F57E0; height: 6px; }
                .cc-salary .rc-slider-handle {
                    width: 22px; height: 22px;
                    margin-top: -8px;
                    background: #3F57E0;
                    border: 3px solid #fff;
                    box-shadow: 0 2px 8px rgba(63,87,224,.45);
                    opacity: 1;
                }
                .cc-salary .rc-slider-handle:hover,
                .cc-salary .rc-slider-handle-dragging {
                    border-color: #fff !important;
                    box-shadow: 0 2px 14px rgba(63,87,224,.65) !important;
                }
            `}</style>

            {/* Value display */}
            <div className="flex items-center justify-between mb-5">
                <div>
                    <p className="text-[11px] text-gray-400 font-semibold uppercase tracking-wider mb-0.5">Min</p>
                    <p className="text-[17px] font-bold text-[#0f172a]">{fmt(minSalary)}</p>
                </div>
                <div className="flex-1" />
                <div className="text-right">
                    <p className="text-[11px] text-gray-400 font-semibold uppercase tracking-wider mb-0.5">Max</p>
                    <p className="text-[17px] font-bold text-[#0f172a]">
                        {maxSalary >= MAX ? '$300k+' : fmt(maxSalary)}
                    </p>
                </div>
            </div>

            {/* rc-slider Range */}
            <div className="cc-salary px-1">
                <Slider
                    range
                    min={MIN}
                    max={MAX}
                    step={STEP}
                    value={[minSalary, maxSalary]}
                    onChange={([min, max]) => {
                        setMinSalary(min);
                        setMaxSalary(max);
                    }}
                    allowCross={false}
                />
            </div>

            {/* Scale */}
            <div className="flex justify-between mt-3 text-[11px] text-gray-400">
                <span>$0</span>
                <span>$150k</span>
                <span>$300k+</span>
            </div>
        </div>
    );
};

export default JobHeaderDDSalary;
